import axios, { AxiosResponse } from 'axios';
import { References } from './References';
import { Helpers } from './Helpers';
import StaticStorage from './StaticStorage';

export class HttpRequest {
    static get = async (apiUrl: string): Promise<AxiosResponse> => {
        const reqHeader = new RequestHeaders();
        const header = reqHeader.headers();
        if (!apiUrl.startsWith('/')) {
            apiUrl = '/' + apiUrl;
        }
        let url = reqHeader.url + apiUrl;
        return new Promise((resolve, reject) => {
            axios.get(url, {
                headers: header
            })
                .then(async response => {
                    if (response.status === 200) {
                        if (response.data.error === "") {
                            resolve(response);
                        } else if (response.data.error !== "") {
                            if (response.data.error.code) {
                                if (response.data.error.code === "refresh_key_required") {
                                    sessionStorage.setItem('isResfreshing', '1');
                                    let isResfreshed = await HttpRequest.refreshToken();
                                    sessionStorage.setItem('isResfreshing', '0');
                                    if (isResfreshed) {
                                        return await HttpRequest.get(apiUrl);
                                    }
                                    else {
                                        HttpRequest.userUnauthorized();
                                    }
                                }
                                else {
                                    if (response.data.error.code === "unauthorized") {
                                        HttpRequest.userUnauthorized();
                                    }
                                }
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log("Error while calling Get API - details: " + JSON.stringify(error));
                    reject(error);
                })
        })
    };
    static post = async (apiUrl: string, dataToPost): Promise<AxiosResponse> => {
        const reqHeader = new RequestHeaders();
        const header = reqHeader.headers();
        if(!apiUrl.startsWith('/')){
            apiUrl = '/' + apiUrl;
        }
        let url = reqHeader.url + apiUrl;        
        let response;
        try {
            response = await axios.post(url, dataToPost, {
                headers: header
            });
            if (response.status === 200) {
                if (response.data.error === "") {
                } else if (response.data.error != "") {
                    if (response.data.error.code) {
                        if (response.data.error.code === "refresh_key_required") {
                            sessionStorage.setItem('isResfreshing', '1');
                            let isResfreshed = await HttpRequest.refreshToken();
                            sessionStorage.setItem('isResfreshing', '0');
                            if (isResfreshed) {
                                return await HttpRequest.post(apiUrl, dataToPost);
                            }
                            else {
                                HttpRequest.userUnauthorized();
                            }
                        }
                        else {
                            if (response.data.error.code === "unauthorized") {
                                HttpRequest.userUnauthorized();
                            }
                        }
                    }
                }
            }
        } catch (e) {
            console.log("Error post request - MS Teams Addin");
            console.error(e);
            response = { status: null };
        }
        return Promise.resolve(response);
    };
    static postToServer = async (url, dataToPost) => {
        const header = {
            'content-type': 'application/json'
        };
        let response;
        try {
            response = await axios.post(url, dataToPost, {
                headers: header
            });

        } catch (e) {
            console.log("Error post request - MS Teams Addin");
            console.error(e);
            response = { status: null };
        }
        return response;
    }; 
    static refreshToken = async () => {
        try {
            const response = await HttpRequest.post(References.refreshTokenApi, "");
            if (response.status === 200) {
                if (response.data.error === "") {
                    if (response.data.success.data.key) {
                        await HttpRequest.updateNewToken(response.data.success.data.key);
                        return true;
                    }
                }
            }
        }
        catch (err) {
            console.error('Refreshing token error: ' + JSON.stringify(err))
            return false;
        }
    };
    static updateNewToken = async (key) => {
        Helpers.saveToLocalStorage('apiKey', key);

        //save new token to back-end
        //Save credentials to back-end          
        let formData = new FormData();
        formData.append('token', key);
        await axios.post('/account/UpdateToken', formData);
    };
    static userUnauthorized = () => {
        localStorage.clear();        
        var path = window.location.pathname.replace('/', '');
        var from = 'from=' + path;
        window.location.href = 'signin?' + from;
    }    
};


export class RequestHeaders {
    url: string;
    apiKey: string;
    constructor() {
        let savedUrl = localStorage?.getItem("url") ?? StaticStorage().getItem("url");
        if(savedUrl){
            if(savedUrl.endsWith('/')){
                savedUrl = savedUrl.substring(0, savedUrl.length - 1);
            }
            this.url = savedUrl;
        }              
        this.apiKey = localStorage.getItem("apiKey") ?? StaticStorage().getItem("apiKey");        
    };        
    headers() {
        return { ...apiHeaders, "x-api-key": "" + this.apiKey + "" }
    };
}

const apiHeaders = {
    "Content-type": "application/x-www-form-urlencoded",
    "x-api-channel": "microsoft-teams"
};
export interface IMigrated {
    migrated: boolean;
    new_url: string
}